<template>
  <div id="data-list-list-view" class="vx-col w-full mb-base">
    <project-side-view
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      @onProjectUpdated="projectUpdated"
      @onProjectInserted="projectInserted"
    />
    <vx-card ref="listCard" :title="$t('CashFlow.Project.Title')" title-color="black" refresh-content-action @refresh="refreshProjectList"> 
      <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
              <vs-button class="mr-3 mb-5" type="border" icon-pack="feather" icon="icon-plus" color="primary" @click="addNewData">{{$t('AddNew')}}</vs-button>
            </vs-col>
      </vs-row>
      <vs-table
        ref="table"
        v-model="selected"
        :data="projects"
      >
        <template slot="thead">
          <vs-th sort-key="name">{{$t('CashFlow.Project.Name')}}</vs-th>
          <vs-th sort-key="regionName">{{$t('CashFlow.Project.RegionName')}}</vs-th>
          <vs-th>{{$t('Action')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.regionName }}</p>
              </vs-td>
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id, tr.name)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>

import moduleCashflow from "@/store/cashflow/moduleCashFlow.js";
import projectSideView from "./components/projectSideView";

export default {
  components: {
    projectSideView
  },
  data() {
    return {
      selected: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    projects() {
      return this.$store.state.cashflow.projects;
    }
  },
  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id, code) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: code,
        text: this.$t('CashFlow.Project.ConfirmDelete', { code }),
        accept: this.deleteData,
        parameters: id
      });
    },
    deleteData(id) {
      this.$store.dispatch("cashflow/removeProject", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("CashFlow.Project.ProjectDeleted")
          });
        });
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    projectUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
    },
    projectInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
    },
    refreshProjectList() {
      this.$store.dispatch("cashflow/fetchProjectListItems").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    }
  },
  created() {
    if (!moduleCashflow.isRegistered) {
      this.$store.registerModule("cashflow", moduleCashflow);
      moduleCashflow.isRegistered = true;
    }
  },
  mounted() {
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
      this.$store.dispatch("cashflow/fetchRegionListItems");
    }

    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
        width: 50px;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }

     .con-expand-muckTypes {
     width: 100%;
      .con-btns-muckType {
        display:flex;
        padding:10px;
        padding-bottom:0px;
        justify-content:flex-start;
        align-items:left;
        justify-content:space-between;
        .con-muckTypex {
          .con-muckType-comments {
            padding-left:5px;
          }
        }
      }
    }
  }
}
</style>